module.exports = __webpack_public_path__ + "static/media/tennis.47ac8502.png";